import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import ModalAddComment from "../../components/modals/modalAddComent/ModalAddComment";
import ProductGallery from "../../components/productGallery/ProductGallery";
import SaveBtn from "../../components/saveBtn/SaveBtn";
import FeatureresSearchList from "../../components/searchList/FeatureresSearchList";
import { int2ip } from "../../helpers/helpers";
import { buildGalleryFormData } from "../../helpers/productFormData";
import useOnClickOutside from "../../helpers/useOnClickOutside";
import IconPrint from "../../images/icons/icon_print.svg";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useGetPageUnloadQuery } from "../../redux/services/noLoadingReqAPI";
import { logEventList } from "../logs/logsTypeData";

const statusList = [
    { id: 1, title: "Розбитий" },
    { id: 2, title: "РозбитСколий" },
    { id: 3, title: "Подряпини" },
    { id: 4, title: "Дисплей труп" },
    { id: 5, title: "Розбитий хоум" },
    { id: 6, title: "Пузирі" },
    { id: 7, title: "Корпус" },
    { id: 8, title: "Вігорівша підсвітка" },
    { id: 9, title: "LCD" },
    { id: 10, title: "ICL" },
    { id: 11, title: "MDN" },
    { id: 12, title: "MDN T-ID" },
    { id: 13, title: "МДМ" },
];

const statusShipperList = [
    { id: 1, title: "A" },
    { id: 2, title: "A-" },
    { id: 3, title: "A+" },
    { id: 4, title: "B" },
    { id: 5, title: "B-" },
    { id: 6, title: "B+" },
    { id: 7, title: "C" },
    { id: 8, title: "D" },
];

const titleFeatureIds = [1, 13, 15, 16, 17];

const CurrentProduct = () => {
    const navigate = useNavigate();
    const statusRef = useRef();
    const shipperStatusRef = useRef();
    const galleryImagesRef = useRef([]);

    const permissions = useSelector((state) => state.status.permissions);
    const userPermission = useSelector((state) => state.status.userPermission);
    const isAdmin = +userPermission?.user_permission_type_id === 9;
    const minProductQuantity = isAdmin ? 0 : 1;
    const canManageProductComments = isAdmin;

    const currentcy = useSelector((state) => state.status.currency);

    const featureRef = useRef();
    const inputFeatureRef = useRef();

    const { id } = useParams();
    const [selectedCategory, setSelectedCategory] = useState("");
    const [title, setTitle] = useState("");
    const [featuresList, setFeaturesList] = useState([]);
    const [store, setStore] = useState(0);
    const [shipper, setShipper] = useState(0);
    const [imeiSn, setImeiSn] = useState("");
    const [mpn, setMpn] = useState("");
    const [aModel, setAModel] = useState("");
    const [active, setActive] = useState(0);
    const [reserve, setReserve] = useState(0);
    const [barcode, setBarcode] = useState("");
    const [status, setStatus] = useState("");
    const [statusShipper, setStatusShipper] = useState("");
    const [priceStockShipper, setPriceStockShipper] = useState(0);
    const [statusUnlock, setStatusUnlock] = useState("");
    const [statusBattery, setStatusBattery] = useState(0);
    const [dropboxFolder, setDropboxFolder] = useState("");
    const [quantity, setQantity] = useState(1);
    const [isQuantityChanged, setIsQuantityChanged] = useState(false);
    const [priceStockUsd, setPriceStockUsd] = useState(null);
    const [priceStock, setPriceStock] = useState(null);
    const [priceUsd, setPriceUsd] = useState(null);
    const [price, setPrice] = useState(null);
    const [comments, setComments] = useState([]);
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editingCommentText, setEditingCommentText] = useState("");
    const [is_website, setIsWebsite] = useState(0);
    const [is_exchange, setIsExchange] = useState(0);
    const [galleryImages, setGalleryImages] = useState([]);

    const [targetFeatureId, setTargetFeatureId] = useState(0);

    const [showCommentModal, setShowCommentModal] = useState(false);
    const [isShowStatusDropdown, setIsShowStatusDropdown] = useState(false);
    const [isShowShipperStatusDropdown, setIsShowShipperStatusDropdown] = useState(false);

    const searchItemParams = inputFeatureRef?.current?.value ? `&search=${inputFeatureRef.current.value}` : "";

    const { data: categorySelect } = useGetPageQuery("categories/select");
    const { data: product, refetch: refetchProduct } = useGetPageQuery("products/" + id);
    const { data: features } = useGetPageQuery("features?per_page=100&category_id=" + selectedCategory);
    const { data: stores } = useGetPageQuery("stores?permission=product&per_page=200");
    const { data: shippers } = useGetPageQuery("shippers?per_page=100");
    const [sendForm, { isLoading, isError }] = useSendFormMutation();
    const [acceptProduct, { isError: acceptProductIsError }] = useSendFormMutation();
    const { data: items } = useGetPageUnloadQuery("feature-items?feature_id=" + targetFeatureId + searchItemParams, {
        skip: !targetFeatureId,
    });

    const featureInputHandler = (text, id) => {
        if (featuresList.find((feat) => feat.id === id)) {
            const currentfeature = featuresList.find((feat) => feat.id === id);
            currentfeature.value = text;
            setFeaturesList([...featuresList.filter((feature) => feature.id !== id), currentfeature]);
        } else {
            setFeaturesList([...featuresList, { id: id, value: text }]);
        }
    };

    useEffect(() => {
        const manufacturer = featuresList.filter((feater) => feater?.id === 1)[0]?.value ?? "";
        const model = featuresList.filter((feater) => feater?.id === 13)[0]?.value ?? "";
        const mamory = featuresList.filter((feater) => feater?.id === 15)[0]?.value ?? "";
        const color = featuresList.filter((feater) => feater?.id === 16)[0]?.value ?? "";
        const operator = featuresList.filter((feater) => feater?.id === 17)[0]?.value ?? "";
        const hasTitleFeatures = featuresList.some(
            (feature) => titleFeatureIds.includes(feature.id) && feature.value?.trim(),
        );
        const titleFromFeatures = `${manufacturer} ${model} ${mamory} ${color} ${operator}`.replace(/\s+/g, " ").trim();

        if (hasTitleFeatures) {
            setTitle(titleFromFeatures);
        } else if (product?.title) {
            setTitle((currentTitle) => currentTitle.trim() || product.title);
        }
    }, [featuresList, product?.title]);

    useEffect(() => {
        if (product) {
            setFeaturesList([
                ...product.features.map((feature) => {
                    return { id: feature.id, value: feature.values.value };
                }),
            ]);
            setTitle(product.title);
            setSelectedCategory(product.category_id);
            setStore(product.store_id);
            setShipper(product.shipper_id);
            setImeiSn(product.imei_sn);
            setMpn(product.mpn);
            setAModel(product.a_model);
            setActive(+product.active);
            setReserve(+product.reserve);
            setBarcode(product.barcode);
            setStatus(product.status);
            setStatusShipper(product.status_shipper);
            setPriceStockShipper(product.price_stock_shipper);
            setStatusUnlock(product.status_unlock);
            setStatusBattery(product.status_battery);
            setDropboxFolder(product.dropbox_folder);
            setQantity(product.quantity);
            setIsQuantityChanged(false);
            setPriceStockUsd(product.price_stock_usd.toString());
            setPriceUsd(product.price_usd.toString());
            setPriceStock(Math.round(product.price_stock / 10) * 10);
            setPrice(Math.round(product.price / 10) * 10); //Math.round(product.price.toString());
            setComments(product.comments ?? []);
            setIsWebsite(+product.is_website);
            setIsExchange(+product.is_exchange);
            setGalleryImages(product.gallery_images || product.gallery || product.gallary || product.images || []);
            galleryImagesRef.current = product.gallery_images || product.gallery || product.gallary || product.images || [];
        }
    }, [product]);

    useEffect(() => {
        const outsideHandleClick = (e) => {
            if (
                featureRef.current &&
                !e.composedPath().includes(featureRef.current) &&
                inputFeatureRef.current &&
                !e.composedPath().includes(inputFeatureRef.current)
            ) {
                setTargetFeatureId(0);
            }
        };

        document.body.addEventListener("click", outsideHandleClick);

        return () => {
            document.body.removeEventListener("click", outsideHandleClick);
        };
    }, []);

    const getProductFormData = (newComments = []) => {
        return {
            title: title.trim() || product?.title || "",
            store_id: store,
            category_id: selectedCategory,
            features: featuresList,
            shipper_id: shipper,
            imei_sn: imeiSn,
            mpn: mpn,
            a_model: aModel,
            barcode: barcode,
            status: status,
            status_shipper: statusShipper,
            price_stock_shipper: priceStockShipper,
            status_unlock: statusUnlock,
            status_battery: statusBattery,
            dropbox_folder: dropboxFolder,
            quantity: isAdmin || isQuantityChanged ? normalizeProductQuantity(quantity) : product?.quantity,
            price_stock_usd: +priceStockUsd,
            price_stock: +priceStock,
            price_usd: +priceUsd,
            price: +price,
            reserve: +reserve,
            active: +active,
            comments: newComments,
            is_website: +is_website,
            is_exchange: +is_exchange,
        };
    };

    const normalizeProductQuantity = (value) => {
        const numericValue = Number(value);

        if (!Number.isFinite(numericValue)) {
            return minProductQuantity;
        }

        return Math.max(minProductQuantity, Math.trunc(numericValue));
    };

    const quantityChangeHandler = (event) => {
        const { value } = event.target;

        setIsQuantityChanged(true);

        if (value === "") {
            setQantity(value);
            return;
        }

        setQantity(normalizeProductQuantity(value));
    };

    const sendFormHandler = async () => {
        try {
            await sendForm({ body: getProductFormData(), url: "products/" + id, method: "PUT" }).unwrap();
            await refetchProduct();
            navigate("/products");
        } catch (error) {
            console.log(error);
        }

        // if (!isError) {
        //     succsesDataChangeAlert();
        // }
    };

    const addCommentHandler = async (comment) => {
        const trimmedComment = comment.trim();

        if (!trimmedComment) {
            return;
        }

        await sendForm({
            body: { text: trimmedComment },
            url: `products/${id}/comments`,
            method: "POST",
        }).unwrap();
        await refetchProduct();
        setShowCommentModal(false);
    };

    const startEditCommentHandler = (comment) => {
        setEditingCommentId(comment.id);
        setEditingCommentText(comment.text ?? "");
    };

    const cancelEditCommentHandler = () => {
        setEditingCommentId(null);
        setEditingCommentText("");
    };

    const saveEditCommentHandler = async (commentId) => {
        const trimmedComment = editingCommentText.trim();

        if (!trimmedComment) {
            return;
        }

        await sendForm({
            body: { text: trimmedComment },
            url: `products/${id}/comments/${commentId}`,
            method: "PUT",
        }).unwrap();
        await refetchProduct();
        cancelEditCommentHandler();
    };

    const deleteCommentHandler = async (commentId) => {
        if (!window.confirm("Видалити коментар?")) {
            return;
        }

        await sendForm({
            url: `products/${id}/comments/${commentId}`,
            method: "DELETE",
        }).unwrap();
        await refetchProduct();
        cancelEditCommentHandler();
    };

    const setpPriceHandler = (e, isUsd) => {
        if (isUsd) {
            let price = +e.target.value * currentcy;
            let priceUsd = +e.target.value;
            const isMoreThentwoNumAfterDot = priceUsd.toString().split(".")[1]?.length > 2;

            if (isMoreThentwoNumAfterDot) {
                priceUsd = priceUsd.toFixed(2);
            }

            setPrice(Math.round(price / 10) * 10);
            setPriceUsd(priceUsd);
        } else {
            let price = +e.target.value;
            let priceUsd = +e.target.value / currentcy;
            const isMoreThentwoNumAfterDot = price.toString().split(".")[1]?.length > 2;

            if (isMoreThentwoNumAfterDot) {
                price = Math.round(price / 10) * 10;
            }

            setPrice(Math.round(price / 10) * 10);
            setPriceUsd(priceUsd.toFixed(2));
        }
    };

    const setStokPriceHandler = (e, isUsd) => {
        if (isUsd) {
            let price = +e.target.value * currentcy;
            let priceUsd = +e.target.value;
            const isMoreThentwoNumAfterDot = priceUsd.toString().split(".")[1]?.length > 2;

            if (isMoreThentwoNumAfterDot) {
                priceUsd = priceUsd.toFixed(2);
            }

            setPriceStock(Math.round(price / 10) * 10); // Math.round(price);
            setPriceStockUsd(priceUsd);
        } else {
            let price = +e.target.value;
            let priceUsd = +e.target.value / currentcy;
            const isMoreThentwoNumAfterDot = price.toString().split(".")[1]?.length > 2;

            if (isMoreThentwoNumAfterDot) {
                price = Math.round(price / 10) * 10;
            }

            setPriceStock(Math.round(price / 10) * 10);
            setPriceStockUsd(priceUsd.toFixed(2));
        }
    };
    const setTragetInputidHandler = (id) => {
        setTargetFeatureId(id);
    };

    const onSelectFeatureHandler = (feature) => {
        featureInputHandler(feature.title, +feature.feature_id);
        setTargetFeatureId(0);
    };

    const setstatusHandler = (value) => {
        setStatus((prev) => prev + value.title + ` `);
    };

    const setstatusShipperHandler = (value) => {
        setStatusShipper((prev) => prev + value.title + ` `);
    };

    const galleryImagesChangeHandler = (images) => {
        galleryImagesRef.current = images;
        setGalleryImages(images);
    };

    const deleteGalleryImageHandler = async (image) => {
        if (!image?.id) {
            return;
        }

        await sendForm({ url: `products/${id}/gallery/${image.id}`, method: "DELETE" }).unwrap();
    };

    const orderGalleryImagesHandler = async (images) => {
        const imageIds = images.map((image) => image.id).filter(Boolean);

        if (imageIds.length < 1) {
            return;
        }

        await sendForm({
            body: { image_ids: imageIds },
            url: `products/${id}/gallery/order`,
            method: "PUT",
        }).unwrap();
    };

    const uploadGalleryFilesHandler = async (files) => {
        if (files.length < 1) {
            return;
        }

        const updatedProduct = await sendForm({
            body: buildGalleryFormData(files),
            url: `products/${id}/gallery`,
            method: "POST",
        }).unwrap();

        const nextGalleryImages =
            updatedProduct.gallery_images || updatedProduct.galleryImages || updatedProduct.gallery || updatedProduct.images || [];

        galleryImagesRef.current = nextGalleryImages;
        setGalleryImages(nextGalleryImages);
        await refetchProduct();
    };

    useOnClickOutside(statusRef, () => setIsShowStatusDropdown(false));
    useOnClickOutside(shipperStatusRef, () => setIsShowShipperStatusDropdown(false));

    // const acceptProductHandler = async () => {
    //     const formData = {
    //         product_ids: [id],
    //     };

    //     await acceptProduct({ body: formData, url: "products/accept", method: "POST" }).unwrap();
    //     await refetchProduct();

    //     if (!acceptProductIsError) {
    //         succsesDataChangeAlert();
    //     }
    // };

    return (
        <>
            {product && categorySelect && features && stores && shippers && (
                <div className="content">
                    <ModalAddComment
                        showCommentModal={showCommentModal}
                        setShowCommentModal={setShowCommentModal}
                        addCommentHandler={addCommentHandler}
                    />
                    <SaveBtn
                        isLoading={isLoading}
                        onBtnClick={sendFormHandler}
                    />
                    <div className="col-12">
                        <div className="d-flex justify-content-between">
                            <h1>
                                ID:{product.id} | {product.title}
                            </h1>
                            <Link
                                to={"/barcode/" + product.id + "/" + product.quantity}
                                target="_blank"
                            >
                                <div>
                                    <img
                                        src={IconPrint}
                                        alt="React Logo"
                                        style={{ width: "41px", height: "41px", cursor: "pointer" }}
                                    />
                                </div>
                            </Link>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-6">
                                    <div className="card card-default">
                                        <div className="card-header d-flex justify-content-between">
                                            Інформація про товар
                                            <div className="d-flex gap-3 aline-items-center">
                                                {/* <div className="custom-control custom-checkbox float-right text-danger mx-2">
                                                <input type="checkbox" id="check_is_muto" name="is_muto" className="form-check-input me-2" />
                                                <label className="custom-control-label">ВП</label>
                                            </div> */}
                                                <div className="custom-control custom-checkbox float-right">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        checked={!!+is_exchange}
                                                        onChange={(e) => setIsExchange(+e.target.checked)}
                                                    />
                                                    <label className="custom-control-label">З обміну</label>
                                                </div>
                                                <div className="custom-control custom-checkbox float-right">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        checked={!!+reserve}
                                                        onChange={(e) => setReserve(+e.target.checked)}
                                                    />
                                                    <label className="custom-control-label">Зарезервовано</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-md-8 col-sm-12">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label">Назва</label>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            className="form-control"
                                                            value={title}
                                                            onChange={(e) => setTitle(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 col-sm-12">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label">Постачальник</label>
                                                        <select
                                                            name="shipper_id"
                                                            className="form-select"
                                                            value={shipper}
                                                            onChange={(e) => setShipper(e.target.value)}
                                                        >
                                                            <option value="0">Не вибрано</option>
                                                            {shippers.data.map((shipper) => {
                                                                return (
                                                                    <option
                                                                        key={shipper.id}
                                                                        value={shipper.id}
                                                                    >
                                                                        {shipper?.title_short}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-md-6 col-sm-12">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label">IMEI/SN</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={imeiSn}
                                                            onChange={(e) => setImeiSn(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3 col-sm-6">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label">MPN</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            minLength="5"
                                                            maxLength="5"
                                                            value={mpn}
                                                            onChange={(e) => setMpn(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3 col-sm-6">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label">A model</label>
                                                        <input
                                                            type="text"
                                                            name="model"
                                                            className="form-control"
                                                            minLength="5"
                                                            maxLength="5"
                                                            value={aModel}
                                                            onChange={(e) => setAModel(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group mb-3">
                                                <label className="form-label">Barcode</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={barcode}
                                                    onChange={(e) => setBarcode(e.target.value)}
                                                />
                                            </div>

                                            <div className="row">
                                                <div
                                                    className="form-group mb-3 col-12 col-md-6"
                                                    style={{ maxWidth: "100%" }}
                                                    ref={statusRef}
                                                >
                                                    <label className="form-label">Стан</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={status}
                                                        onChange={(e) => setStatus(e.target.value)}
                                                        onFocus={() => setIsShowStatusDropdown(true)}
                                                    />
                                                    {isShowStatusDropdown && (
                                                        <FeatureresSearchList
                                                            style={{ maxWidth: "300px" }}
                                                            features={statusList ? statusList : []}
                                                            onSelectFeatureHandler={setstatusHandler}
                                                        />
                                                    )}
                                                </div>

                                                <div
                                                    className="form-group mb-3 col-12 col-md-6"
                                                    ref={shipperStatusRef}
                                                >
                                                    <label className="form-label">Стан для постачальника</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={statusShipper}
                                                        onChange={(e) => setStatusShipper(e.target.value)}
                                                        onFocus={() => setIsShowShipperStatusDropdown(true)}
                                                    />
                                                    {isShowShipperStatusDropdown && (
                                                        <FeatureresSearchList
                                                            style={{ maxWidth: "300px" }}
                                                            features={statusShipperList ? statusShipperList : []}
                                                            onSelectFeatureHandler={setstatusShipperHandler}
                                                        />
                                                    )}
                                                </div>
                                                {/* <div className="form-group mb-3 col-12 col-md-4">
                                                    <label className="form-label">Закупка</label>
                                                    <input
                                                        type="text"
                                                        name="price_stock_shipper"
                                                        className="form-control"
                                                        value={priceStockShipper}
                                                        onChange={(e) => setPriceStockShipper(e.target.value)}
                                                    />
                                                </div> */}
                                            </div>

                                            <div className="row">
                                                <div className="form-group mb-3 col-12">
                                                    <label className="form-label">Стан розблокування</label>
                                                    <textarea
                                                        className="form-control"
                                                        value={statusUnlock}
                                                        onChange={(e) => setStatusUnlock(e.target.value)}
                                                    ></textarea>
                                                </div>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label className="form-label">Стан батареї %</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={statusBattery}
                                                    onChange={(e) => setStatusBattery(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group mb-3">
                                                <label className="form-label">Посилання на телеграм</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={dropboxFolder}
                                                    onChange={(e) => setDropboxFolder(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card card-default">
                                        <div className="card-header d-flex justify-content-between">
                                            Коментарі
                                            <div className="float-right">
                                                <div
                                                    className="add-comment__button"
                                                    onClick={() => setShowCommentModal(true)}
                                                >
                                                    Додати
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="card-body"
                                            style={{ height: "295px", overflowY: "auto" }}
                                        >
                                            {comments.length > 0 ? (
                                                <table className="table table-striped">
                                                    <tbody>
                                                        {comments.map((comment) => {
                                                            return (
                                                                <tr key={comment.id}>
                                                                    <td>
                                                                        <div>
                                                                            {comment.user?.name}
                                                                            <span className="float-end text-muted">
                                                                                {moment(comment.created_at).format(
                                                                                    "DD.MM.YYYY HH:MM",
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        {editingCommentId === comment.id ? (
                                                                            <div className="mt-2">
                                                                                <textarea
                                                                                    className="form-control"
                                                                                    value={editingCommentText}
                                                                                    onChange={(e) =>
                                                                                        setEditingCommentText(
                                                                                            e.target.value,
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <div className="d-flex justify-content-end gap-2 mt-2">
                                                                                    <button
                                                                                        className="btn btn-secondary btn-sm"
                                                                                        onClick={cancelEditCommentHandler}
                                                                                    >
                                                                                        Скасувати
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn btn-primary btn-sm"
                                                                                        onClick={() =>
                                                                                            saveEditCommentHandler(
                                                                                                comment.id,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Зберегти
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="d-flex justify-content-between gap-2 mt-1">
                                                                                <div>{comment.text}</div>
                                                                                {canManageProductComments ? (
                                                                                    <div className="d-flex gap-2">
                                                                                        <button
                                                                                            className="btn btn-outline-secondary btn-sm"
                                                                                            onClick={() =>
                                                                                                startEditCommentHandler(
                                                                                                    comment,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Редагувати
                                                                                        </button>
                                                                                        <button
                                                                                            className="btn btn-outline-danger btn-sm"
                                                                                            onClick={() =>
                                                                                                deleteCommentHandler(
                                                                                                    comment.id,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Видалити
                                                                                        </button>
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div className="alert alert-info">
                                                    Коментарі відсутні
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="card card-default">
                                        <div className="card-header">Логи товару</div>
                                        <div
                                            className="card-body"
                                            style={{ height: "295px", overflowY: "auto" }}
                                        >
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th className="no-mobile">Менеджер</th>
                                                        <th className="no-mobile">Подія</th>
                                                        <th className="no-mobile">Інформація</th>
                                                        <th className="no-mobile">Дата</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {product?.logs.length > 0 &&
                                                        product.logs.map((log) => {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        {log?.user?.name}
                                                                        {/* <div>
                                                            <span className="badge bg-warning text-dark mx-1">
                                                                PC (Windows )
                                                            </span>
                                                            Chrome 75.0.3770.144
                                                        </div> */}
                                                                        <div>
                                                                            <span className="badge bg-secondary ">
                                                                                IP: {int2ip(log.ip)}
                                                                            </span>
                                                                        </div>
                                                                        <div className="on-mobile mt-2">
                                                                            <table className="table table-bordered">
                                                                                <tbody>
                                                                                    {Object.keys(
                                                                                        JSON.parse(log.changes),
                                                                                    ).map((change) => {
                                                                                        return (
                                                                                            <tr>
                                                                                                <td>{change}</td>
                                                                                                <td>
                                                                                                    {
                                                                                                        JSON.parse(
                                                                                                            log.changes,
                                                                                                        )[change]
                                                                                                    }
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div class="note note-note on-mobile">
                                                                            {logEventList.find(
                                                                                (event) =>
                                                                                    event.evenType === log.event &&
                                                                                    event.logable_type ===
                                                                                        log.logable_type,
                                                                            ).title +
                                                                                " " +
                                                                                moment(log.created_at).format(
                                                                                    "DD.MM.YYYY HH:mm",
                                                                                )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        {
                                                                            logEventList.find(
                                                                                (event) =>
                                                                                    event.evenType === log.event &&
                                                                                    event.logable_type ===
                                                                                        log.logable_type,
                                                                            ).title
                                                                        }
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        <table className="table table-bordered">
                                                                            <tbody>
                                                                                {Object.keys(
                                                                                    JSON.parse(log.changes),
                                                                                ).map((change) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <td>{change}</td>
                                                                                            <td>
                                                                                                {
                                                                                                    JSON.parse(
                                                                                                        log.changes,
                                                                                                    )[change]
                                                                                                }
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        {moment(log.created_at).format(
                                                                            "DD.MM.YYYY HH:mm",
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-6">
                                    <div className="card card-default">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            Магазини
                                            {product.is_coming ? (
                                                <div className="flex-start text-danger">
                                                    Товар у дорозі
                                                    {/* <button
                                                        className="btn btn-primary ms-3"
                                                        onClick={acceptProductHandler}
                                                    >
                                                        Прийняти
                                                    </button> */}
                                                </div>
                                            ) : null}
                                            <div className="d-flex">
                                                <div className="custom-control custom-checkbox float-right mx-2">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        checked={!!+is_website}
                                                        onChange={(e) => setIsWebsite(+e.target.checked)}
                                                    />
                                                    <label className="custom-control-label">Відображати на сайті</label>
                                                </div>
                                                <div className="custom-control custom-checkbox float-right mx-2">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        checked={!!+active}
                                                        onChange={(e) => setActive(+e.target.checked)}
                                                    />
                                                    <label className="custom-control-label">Активний</label>
                                                </div>
                                                {/* <div className="custom-control custom-checkbox float-right" style={{ paddingRight: "10px" }}>
                                                <input type="checkbox" id="rozetka_enabled" name="rozetka" className="form-check-input me-2" />
                                                <label className="custom-control-label">Rozetka</label>
                                            </div> */}
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-sm-6 col-md-3">
                                                    <label className="form-label">Кількість</label>
                                                    <input
                                                        type="number"
                                                        name="stock"
                                                        className="form-control"
                                                        value={quantity}
                                                        min={minProductQuantity}
                                                        step="1"
                                                        onBlur={(e) => setQantity(normalizeProductQuantity(e.target.value))}
                                                        onChange={quantityChangeHandler}
                                                    />
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-3 no-padding-left">
                                                    <label className="form-label">Склад</label>
                                                    <select
                                                        name="store_id"
                                                        className="form-select"
                                                        value={store}
                                                        onChange={(e) => setStore(e.target.value)}
                                                    >
                                                        {stores.data.map((store) => {
                                                            return (
                                                                <option
                                                                    value={store.id}
                                                                    key={store.id}
                                                                >
                                                                    {store.title}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                {+userPermission.user_permission_type_id === 9 && (
                                                    <div className="col-12 col-sm-6 col-md-3 no-padding-left">
                                                        <label className="form-label">Закупка</label>
                                                        <div>
                                                            <input
                                                                type="number"
                                                                style={{ width: "47%", display: "inline-block" }}
                                                                value={priceStockUsd || null}
                                                                onChange={(e) => setStokPriceHandler(e, true)}
                                                                className="form-control me-1"
                                                            />
                                                            <input
                                                                type="number"
                                                                style={{ width: "47%", display: "inline-block" }}
                                                                value={priceStock || null}
                                                                onChange={(e) => setStokPriceHandler(e)}
                                                                className="form-control me-1"
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="col-12 col-sm-6 col-md-3 no-padding-left">
                                                    <label className="form-label">Ціна</label>
                                                    <div>
                                                        <input
                                                            type="number"
                                                            style={{ width: "47%", display: "inline-block" }}
                                                            className="form-control me-1"
                                                            value={priceUsd || null}
                                                            onChange={(e) => setpPriceHandler(e, true)}
                                                        />
                                                        <input
                                                            type="number"
                                                            style={{ width: "47%", display: "inline-block" }}
                                                            className="form-control me-1"
                                                            value={price || null}
                                                            onChange={(e) => setpPriceHandler(e)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card card-default">
                                        <div className="card-header">Категорія</div>
                                        <div
                                            className="card-body"
                                            id="product_categories"
                                        >
                                            <select
                                                className="form-select"
                                                onChange={(e) => setSelectedCategory(e.target.value)}
                                                value={selectedCategory}
                                            >
                                                {categorySelect.map((selectCategory) => {
                                                    return (
                                                        <option
                                                            value={selectCategory.id}
                                                            key={selectCategory.id}
                                                        >
                                                            {"\u00A0\u00A0\u00A0\u00A0\u00A0".repeat(
                                                                selectCategory.level,
                                                            ) + selectCategory.title}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="card card-default">
                                        <div className="card-header">Характеристики</div>
                                        <div className="card-body">
                                            <ul className="list_purchaches">
                                                {features.data.map((feature) => {
                                                    return (
                                                        <li
                                                            className="mb-3"
                                                            key={feature.id}
                                                        >
                                                            <div className="form-group row">
                                                                <label className="property col-sm-4 control-label">
                                                                    {feature.title}
                                                                </label>
                                                                <div className="col-sm-8">
                                                                    <input
                                                                        ref={
                                                                            feature.id === targetFeatureId
                                                                                ? inputFeatureRef
                                                                                : null
                                                                        }
                                                                        className="form-control"
                                                                        type="text"
                                                                        autoComplete="off"
                                                                        onChange={(e) =>
                                                                            featureInputHandler(
                                                                                e.target.value,
                                                                                feature.id,
                                                                            )
                                                                        }
                                                                        onFocus={() =>
                                                                            setTragetInputidHandler(feature.id)
                                                                        }
                                                                        value={
                                                                            featuresList?.find(
                                                                                (feat) => feat.id === feature.id,
                                                                            )?.value || ""
                                                                        }
                                                                    />
                                                                    {feature.id === targetFeatureId ? (
                                                                        <div
                                                                            ref={
                                                                                feature.id === targetFeatureId
                                                                                    ? featureRef
                                                                                    : null
                                                                            }
                                                                        >
                                                                            <FeatureresSearchList
                                                                                features={items ? items : []}
                                                                                onSelectFeatureHandler={
                                                                                    onSelectFeatureHandler
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                                <div className="clearfix"></div>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                            <ProductGallery
                                                existingImages={galleryImages}
                                                onExistingImagesChange={galleryImagesChangeHandler}
                                                onUploadFiles={uploadGalleryFilesHandler}
                                                onDeleteExistingImage={deleteGalleryImageHandler}
                                                onOrderExistingImages={orderGalleryImagesHandler}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="ck_padding no-mobile d-none">
                                <h2>Опис товару</h2>
                                <textarea name="annotation"></textarea>
                            </div>
                            {permissions.includes("product_edit") || permissions.includes("all") ? (
                                <div className="saves_block">
                                    <button
                                        name="user_info"
                                        className="btn btn-primary"
                                        onClick={sendFormHandler}
                                    >
                                        {isLoading ? "Завантаження" : "Зберегти"}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentProduct;
